import { useEffect } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";

import { selectHeadlight } from "../renderSlice";

export function useHandleHeadlight() {
    const {
        state: { view },
    } = useExplorerGlobals();
    const headlight = useAppSelector(selectHeadlight);

    useEffect(() => {
        if (!view) {
            return;
        }
        view.modifyRenderState({ headlight });
    }, [view, headlight]);
}
